var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactUsIconRectenggle2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 141,
    height: 85,
    viewBox: "0 0 141 85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_171819",
    "data-name": "\\uADF8\\uB8F9 171819",
    transform: "translate(-5788 -11698)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uC0AC\\uAC01\\uD615_153070",
    "data-name": "\\uC0AC\\uAC01\\uD615 153070",
    transform: "translate(5788 11698)",
    fill: "#f3e3a1",
    stroke: "#f4e3a2",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 27,
    height: 27,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uC0AC\\uAC01\\uD615_153071",
    "data-name": "\\uC0AC\\uAC01\\uD615 153071",
    transform: "translate(5816 11726)",
    fill: "none",
    stroke: "#d7e0ec",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 27,
    height: 27,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uC0AC\\uAC01\\uD615_153072",
    "data-name": "\\uC0AC\\uAC01\\uD615 153072",
    transform: "translate(5844 11698)",
    fill: "none",
    stroke: "#d7e0ec",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 27,
    height: 27,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uC0AC\\uAC01\\uD615_153074",
    "data-name": "\\uC0AC\\uAC01\\uD615 153074",
    transform: "translate(5816 11754)",
    fill: "none",
    stroke: "#d7e0ec",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 27,
    height: 27,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uC0AC\\uAC01\\uD615_153073",
    "data-name": "\\uC0AC\\uAC01\\uD615 153073",
    transform: "translate(5844 11726)",
    fill: "none",
    stroke: "#d7e0ec",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 27,
    height: 27,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uC0AC\\uAC01\\uD615_153075",
    "data-name": "\\uC0AC\\uAC01\\uD615 153075",
    transform: "translate(5872 11698)",
    fill: "none",
    stroke: "#d7e0ec",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 27,
    height: 27,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uC0AC\\uAC01\\uD615_153076",
    "data-name": "\\uC0AC\\uAC01\\uD615 153076",
    transform: "translate(5844 11754)",
    fill: "none",
    stroke: "#d7e0ec",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 27,
    height: 27,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uC0AC\\uAC01\\uD615_153077",
    "data-name": "\\uC0AC\\uAC01\\uD615 153077",
    transform: "translate(5872 11726)",
    fill: "#1876d2",
    stroke: "#1876d2",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 27,
    height: 27,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uC0AC\\uAC01\\uD615_153078",
    "data-name": "\\uC0AC\\uAC01\\uD615 153078",
    transform: "translate(5900 11698)",
    fill: "none",
    stroke: "#d7e0ec",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 27,
    height: 27,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactUsIconRectenggle2);
export default __webpack_public_path__ + "static/media/contact_us_icon_rectenggle2.3ae6e640735795c58c54628972995905.svg";
export { ForwardRef as ReactComponent };